import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import anagraphicReducer from './anagraphic.reducer';
import capabilityReducer from './capability.reducer';
import changeCapabilityForRoleReducer from './changeCapabilityForRole.reducer';
import mediaUploadReducer from './media-upload.reducer';
import modalReducer from './modal.reducer';
import changepassword from './updatePassword.reducer';
import rolesReducer from './roles.reducer';
import commissionsReducer from './commissions.reducer';
import updatesCommissionRelationsReducer from './updates-commission-relations.reducer';
import userReducer from './user.reducer';
import userTimesheetReducer from './user-timesheet-management.reducer';
import updateUserReducer from './update-user.reducer';
import authenticationReducer from './authentication.reducer';
import passwordResetReducer from './passwordReset.reducer';
import searchCommissionsReducer from './search-commissions.reducer';
import searchUserTimesheetsReducer from './search-user-timesheets.reducer';
import downloadUserTimesheetsReducer from './user-timesheet-download.reducer';
import hamburgMenuReducer from './hamburg-menu.reducer';

export const store = configureStore({
  reducer: {
    // project
    modal: modalReducer,
    authentication: authenticationReducer,
    changepassword: changepassword,
    mediaUpload: mediaUploadReducer,
    anagraphic: anagraphicReducer,
    roles: rolesReducer,
    capability: capabilityReducer,
    changeCapabilities: changeCapabilityForRoleReducer,
    commissions: commissionsReducer,
    updateCommissionRelations: updatesCommissionRelationsReducer,
    user: userReducer,
    userTimesheetManagement: userTimesheetReducer,
    updateUser: updateUserReducer,
    resetPassword: passwordResetReducer,
    searchCommissions: searchCommissionsReducer,
    searchUserTimesheets: searchUserTimesheetsReducer,
    downloadUserTimesheets: downloadUserTimesheetsReducer,
    hamburgMenu: hamburgMenuReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector = useSelector.withTypes<RootState>();
